import React from "react";
import { RouteConfig } from "../../../../../config/router/router.config";
import { IAdmin } from "../../../../../model/user/admin/admin.model";

export type AdminEditRouteParam = {
  admin: IAdmin;
};

export const adminEditRoute: RouteConfig = {
  name: "Edit Admin",
  Component: React.lazy(() => import("./AdminEdit.view")),
  path: "/user/admin/edit/:id",
  isPrivate: true,
};
